module.exports = __webpack_public_path__ + "static/media/about1.c438aabb.jpg";